import * as A from 'fp-ts/Array';
import * as Str from 'fp-ts/string';
export var hasMode = function hasMode(mode) {
  return function (_ref) {
    var modes = _ref.modes;
    return A.elem(Str.Eq)(mode, modes);
  };
};